export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'note';

export const REQUIRED_FIELDS = ['note'];
